import React from "react"
import CuratedHotelPage from "../../templates/hotels/CuratedHotelPage"

const Page = () => <CuratedHotelPage hotelKey="castelloDiCasole" locale="fr" />

export default Page
